// 🔑 "SEE ALL ESTIMATED CLOSING COSTS" — the expander under the step-8 SmartEstimate card (Jesse, 2026-11-01; APPROVED by
// Hannah 2026-11-01: shown when constants/smartEstimateFaq FINE_PRINT_V2_APPROVED is true). Its own file with no imports, so
// the card stays loadable by the backend tests that render it (test/helpers/renderSmartEstimateCard).
export const CLOSING_COSTS_EXPANDER_LABEL = 'See all estimated closing costs';
export const INSPECTION_LINE = 'Doorly covers the home inspection; you can order your own at your own expense.';
